<template>
    <modal title="Search Location" width="45" :showModal="showModal" @close-modal="closeModal">
        <div class="flex flex-col" v-loading="loading">


            <div class="w-full mt-2">
                <label class="label">Location</label>
                <auto-complete :customStyle="customStyle" :locationDetails="viewLocationDetails"
                    placeholder="11, Darasimi Street, Mende, Maryland" :value="fullAddress" />
            </div>

            <div class="flex justify-end items-center mt-3">
                <button class="button py-2">Search</button>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    props: {
        showModal: {
            type: Boolean,
            required: true,
        }
    },
    data() {
        return {
        }
    },
    computed: {
        customStyle() {
            return {
                width: '100%',
                padding: '8px 10px',
                borderRadius: '5px',
                border: '1px solid grey'
            }
        },
    },
    methods: {
        closeModal() {
            this.$emit("closeModal");
        },
    },
};
</script>

<style scoped>


.button {
    background: #fcc210;
    color: var(--primaryblue);
    width: 40%;
    font-weight: 500;
    /* margin-top: 3rem; */
}

.new-address-button {
    text-decoration-line: underline;

    color: #da9601;
}

.radio-label span::after {
    background: #bec4d5;
}
</style>